var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineComputing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F38AD149-6994-4DEC-9635-558E25F34AAE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional",
    transform: "translate(-684.000000, -444.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "computing",
    transform: "translate(684.000000, 444.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97070312,22.75 C3.5407033,22.75 1.22070312,20.4299998 1.22070312,15 L1.22070312,9 C1.22070312,3.57000017 3.5407033,1.25 8.97070312,1.25 L14.9707031,1.25 C20.400703,1.25 22.7207031,3.57000017 22.7207031,9 L22.7207031,15 C22.7207031,20.4299998 20.4107032,22.75 14.9707031,22.75 L8.97070312,22.75 Z M2.72070312,9 L2.72070312,15 C2.72070312,19.6100001 4.36070299,21.25 8.97070312,21.25 L14.9707031,21.25 C19.5807033,21.25 21.2207031,19.6100001 21.2207031,15 L21.2207031,9 C21.2207031,4.38999987 19.5807033,2.75 14.9707031,2.75 L8.97070312,2.75 C4.36070299,2.75 2.72070312,4.38999987 2.72070312,9 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7409375,20.2299404 C2.45093751,19.9399404 2.45093751,19.4599409 2.7409375,19.1699409 L19.1909389,2.71994141 C19.4809389,2.42994142 19.9609384,2.42994142 20.2509384,2.71994141 C20.5409384,3.0099414 20.5409384,3.48994133 20.2509384,3.77994132 L3.80093741,20.2299404 C3.66093741,20.3799404 3.47093745,20.4499416 3.27093744,20.4499416 C3.08093745,20.4499416 2.89093751,20.3799404 2.7409375,20.2299404 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3105469,18 L15.3105469,13 C15.3105469,12.59 15.6505459,12.25 16.0605459,12.25 C16.4705459,12.25 16.8105469,12.59 16.8105469,13 L16.8105469,18 C16.8105469,18.41 16.4705459,18.75 16.0605459,18.75 C15.6505459,18.75 15.3105469,18.41 15.3105469,18 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,16.25 C13.09,16.25 12.75,15.91 12.75,15.5 C12.75,15.09 13.09,14.75 13.5,14.75 L18.5,14.75 C18.91,14.75 19.25,15.09 19.25,15.5 C19.25,15.91 18.91,16.25 18.5,16.25 L13.5,16.25 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,8.25 C5.09,8.25 4.75,7.91 4.75,7.5 C4.75,7.09 5.09,6.75 5.5,6.75 L10.5,6.75 C10.91,6.75 11.25,7.09 11.25,7.5 C11.25,7.91 10.91,8.25 10.5,8.25 L5.5,8.25 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineComputing);
export default __webpack_public_path__ + "static/media/vuesax-outline-computing.64f5349099a361585223802c7a597319.svg";
export { ForwardRef as ReactComponent };